var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseIndentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.0625C1.75 2.82088 1.94588 2.625 2.18751 2.625H11.8128C12.0544 2.625 12.2503 2.82088 12.2503 3.0625C12.2503 3.30412 12.0544 3.5 11.8128 3.5H2.18751C1.94588 3.5 1.75 3.30412 1.75 3.0625ZM2.31566 4.94064C2.48651 4.76979 2.76353 4.76979 2.93439 4.94064L4.68444 6.69064C4.8553 6.8615 4.8553 7.1385 4.68444 7.30936L2.93439 9.05936C2.76353 9.23021 2.48651 9.23021 2.31566 9.05936C2.1448 8.8885 2.1448 8.6115 2.31566 8.44064L3.75634 7L2.31566 5.55936C2.1448 5.3885 2.1448 5.1115 2.31566 4.94064ZM6.12512 5.6875C6.12512 5.44588 6.321 5.25 6.56263 5.25H11.8128C12.0544 5.25 12.2503 5.44588 12.2503 5.6875C12.2503 5.92912 12.0544 6.125 11.8128 6.125H6.56263C6.321 6.125 6.12512 5.92912 6.12512 5.6875ZM6.12512 8.3125C6.12512 8.07088 6.321 7.875 6.56263 7.875H11.8128C12.0544 7.875 12.2503 8.07088 12.2503 8.3125C12.2503 8.55412 12.0544 8.75 11.8128 8.75H6.56263C6.321 8.75 6.12512 8.55412 6.12512 8.3125ZM1.75 10.9375C1.75 10.6959 1.94588 10.5 2.18751 10.5H11.8128C12.0544 10.5 12.2503 10.6959 12.2503 10.9375C12.2503 11.1791 12.0544 11.375 11.8128 11.375H2.18751C1.94588 11.375 1.75 11.1791 1.75 10.9375Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIndentIcon);
export default __webpack_public_path__ + "static/media/increaseIndentIcon.0bf98605e0ed17cdac3dd6c2fc1875e4.svg";
export { ForwardRef as ReactComponent };